<template>
  <div class="flex flex-col md:flex-row justify-between items-center gap-8 p-4 md:p-8" style="margin: 0 5%;" id="assortiment">
    <!-- Linker Kaart -->
    <div
      class="relative bg-cover bg-center w-full md:flex-grow h-80 md:h-96 rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-transform duration-300"
      style="background-image: url('oyster.jpg');"
    >
      <router-link to="/assortiment">
        <div class="absolute inset-0 bg-black/25 flex flex-col justify-between p-6 md:p-8 text-white">
          <div>
            <h2 class="text-2xl md:text-4xl font-bold mb-4">Assortiment</h2>
            <span class="text-sm md:text-base block">Bekijk ons uitgebreide aanbod van verse vis en zeevruchten.</span>
          </div>
          <button
            class="absolute bottom-4 right-4 w-12 h-12 md:w-14 md:h-14 bg-sky-500 hover:bg-sky-600 text-white rounded-full flex items-center justify-center shadow-lg transition"
          >
            <i class="fas fa-arrow-right text-lg"></i>
          </button>
        </div>
      </router-link>
    </div>

    <!-- Rechter Kaart -->
    <div
      class="relative bg-cover bg-center w-full md:flex-grow h-80 md:h-96 rounded-2xl shadow-xl overflow-hidden transform hover:scale-105 transition-transform duration-300"
      style="background-image: url('/shrimp.jpg');"
    >
    <a href="/Folder 2025.pdf" target="_blank">
      <div class="absolute inset-0 bg-black/25 flex flex-col justify-between p-6 md:p-8 text-white">
        
        <div>
          <h2 class="text-2xl md:text-4xl font-bold mb-4">Folder</h2>
          <span class="text-sm md:text-base block">Blader door onze nieuwste aanbiedingen en acties.</span>
        </div>
        <button
          class="absolute bottom-4 right-4 w-12 h-12 md:w-14 md:h-14 bg-sky-500 hover:bg-sky-600 text-white rounded-full flex items-center justify-center shadow-lg transition"
        >
          <i class="fas fa-arrow-right text-lg"></i>
        </button>
      </div>
    </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardComponent",
};
</script>

<style scoped>
/* Styling is voornamelijk met Tailwind gedaan */
</style>
